import stripDelimiters from './stripDelimiters'

function normaliseActionName(actionName = '') {
  return stripDelimiters(actionName).trim().toLowerCase()
}

export default function isSameAsCurrentAction({ row, selectedActionName, arenaAction } = {}) {
  if (!row || !selectedActionName || !arenaAction) {
    return false
  }

  const currentActionName = row[`ca_name${arenaAction}`]

  if (!currentActionName || currentActionName === 'blank' || currentActionName === 'pending') {
    return false
  }

  return normaliseActionName(selectedActionName) === normaliseActionName(currentActionName)
}
